import { Box, Button, Grid, Modal, Typography } from "@mui/material";
import React from "react";
import { INotificationModal } from "./INotificationModal";
import InfoIcon from '@mui/icons-material/Info';
import ReportProblemIcon from '@mui/icons-material/ReportProblem';

const css = `
.MuiTypography-root{
    font-size: 14px;
}
`;
const style = {
    position: "absolute" as "absolute",
    top: "40%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    bgcolor: "background.paper",
    boxShadow: 24,
};

function NotificationModal({
    title,
    buttonTitle,
    openModal,
    description,
    noticeType,
    setOpenVerifyModal,
    setConfirm,
    seenDate
}: INotificationModal) {
    const [open, setOpen] = React.useState<boolean>(openModal);
    const handleClose = () => { setOpen(false); setOpenVerifyModal(false) };
    const handelVerify = () => {
        handleClose();
        setConfirm(true);
    };
    React.useEffect(() => {
        setOpen(openModal);
    }, [openModal]);
    return (<>
        <style>{css}</style>
        <Modal open={open}
            onClose={handleClose}
            className="border300"
            aria-labelledby="keep-mounted-modal-title"
            aria-describedby="keep-mounted-modal-description"
        >
            <Box className="ModalCmp" sx={style} style={{ borderRadius: "5px", padding: "30px", direction: 'rtl' }}>
                <div >
                    <Typography className="text-center" style={{ marginBottom: '20px' }}>
                        {noticeType === 'Warning' ? <ReportProblemIcon style={{ color: `${seenDate === null ? '#FF617C' : '#D7DBEC'}`, width: '36px', height: '36px' }} /> :
                            noticeType === 'Information' ? <InfoIcon style={{ color: `${seenDate === null ? '#BBA57A' : '#D7DBEC'}`, width: '36px', height: '36px' }} /> : null}
                    </Typography>
                    <Typography className="text-center !font-bold primaryColorLight-900" style={{ fontSize: '14px' }}>
                        {title}
                    </Typography>
                    <Typography className="text-center primaryColorLight-900 anjomanRegular" style={{ fontSize: '12.5px', marginTop: '10px', marginBottom: '30px' }}>
                        {description}
                    </Typography>
                </div>
                <Grid container spacing={2} xs={12} >
                    <Grid item xs={12} style={{ paddingLeft: '0px' }}>
                        <Button
                            style={{
                                minHeight: ' 42px', fontSize: '15px', alignItems: 'center',
                                paddingTop: '9px'
                            }}
                            onClick={handelVerify}
                            fullWidth
                            className={`btnClass bgPrimaryColorLight witheColor !font-bold `}
                        >
                            {buttonTitle}
                        </Button>
                    </Grid>
                </Grid>
            </Box>

        </Modal>
    </>);
}

export default NotificationModal;